import type { DataSourceOption, SourcesData } from '@stratumn/studio-shared';
import { newError } from '@/services/errors/errors';

import { DatabaseSelector } from '../repositorySelector/repositorySelector';
import { StaticSelector } from '../staticSelector/staticSelector';
import { VariableSelector } from '../variableSelector/variableSelector';

type Props = {
  selectedDataSource: DataSourceOption;
  sourcesData: SourcesData;
  onSourceDataChange: (sourceData: SourcesData) => void;

  id: string;
};
export const RenderSource = (props: Props) => {
  switch (props.selectedDataSource) {
    case 'normalSource':
      return (
        <StaticSelector
          onDataChange={normalSource => {
            props.onSourceDataChange({
              ...props.sourcesData,
              normalSource
            });
          }}
          sourceData={props.sourcesData.normalSource}
        />
      );
    case 'database':
      return (
        <DatabaseSelector
          id={props.id}
          onDataChange={database =>
            props.onSourceDataChange({
              ...props.sourcesData,
              database
            })
          }
          sourceData={props.sourcesData.database}
        />
      );
    case 'stateVariable':
      return (
        <VariableSelector
          onSelected={stateVariable =>
            props.onSourceDataChange({
              ...props.sourcesData,
              stateVariable
            })
          }
          selectedRef={props.sourcesData.stateVariable}
        />
      );
    default:
      newError('DataSource-1234', 'Invalid data source option', true);
      return <></>;
  }
};
